import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CHANGELOG, markChangelogSeen } from '../lib/changelog';

function formatDate(isoDate: string): string {
  // Parse as local time (not UTC) to avoid off-by-one for west-of-UTC users
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function WhatsNew() {
  const navigate = useNavigate();

  useEffect(() => {
    // Mark seen on visit — clears the Dashboard badge on next render
    markChangelogSeen();
  }, []);

  return (
    <main className="min-h-dvh bg-stone-50 flex flex-col items-center py-12 px-4">
      <div className="w-full max-w-2xl">
        {/* Page header */}
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-lg font-semibold text-stone-900">What's New</h1>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="text-sm text-stone-500 hover:text-stone-900 transition-colors"
          >
            ← Dashboard
          </button>
        </div>

        {/* Release entries */}
        <div className="space-y-4">
          {CHANGELOG.map((entry) => (
            <div
              key={entry.version}
              className="bg-white rounded-2xl shadow-sm border border-stone-200 p-6 space-y-1"
            >
              {/* Header row: version badge + optional label + date */}
              <div className="flex items-center gap-2 flex-wrap">
                <span className="px-3 py-1 rounded-full text-xs font-mono font-semibold bg-stone-100 text-stone-600">
                  v{entry.version}
                </span>
                {entry.label && (
                  <span className="px-3 py-1 rounded-full text-xs font-semibold bg-amber-100 text-amber-700">
                    {entry.label}
                  </span>
                )}
                <span className="text-sm text-stone-400 ml-auto">
                  {formatDate(entry.date)}
                </span>
              </div>
              {/* Headline */}
              <p className="text-base font-semibold text-stone-900 pt-2">{entry.headline}</p>
              {/* Feature list */}
              <ul className="list-none space-y-2 pt-1">
                {entry.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-stone-700">
                    <span
                      className="w-1.5 h-1.5 rounded-full bg-amber-400 flex-shrink-0 mt-1.5"
                      aria-hidden="true"
                    />
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
